import { axiosPost } from "./http";

const prexfix = "https://docking.xjtstc.com";
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk';
// const prexfix = 'http://222.128.10.58:9009';
// const prexfix = 'http://biaozhunhua.zjht100.com';

// 查询安检状况列表
export const findPage = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data,
  };
  return axiosPost(`/bizSecuritySituation/findPage`, params);
};

// 根据id查询安检状况详情
export const findOne = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data,
  };
  return axiosPost(`/bizSecuritySituation/findOne`, params);
}; 

// 获取抓拍设备
export const findFaceCaptureMonitorPage = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data,
  };
  return axiosPost(`/resMonitor/findFaceCaptureMonitorPage`, params);
};

